import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {BotatoChatManagerService, DelayedRenderedMessageComponent, DialogViewModelCreatorService} from 'botato-angular-lib';
import {QuizResponseItemData} from '../../type/QuizResponseItemData';
import {TrueFalseQuiz} from './TrueFalseQuiz';
import {TrueFalseQuizResponseItemDataText} from './TrueFalseQuizResponseItemDataText';
import {DeactivateMessageService} from '../../../deactivate-message.service';
import {Subscription} from 'rxjs';
import {TrueFalseQuizUpdateAnswer} from './TrueFalseQuizUpdateAnswer';
import {QuizQuestion} from '../../type/QuizQuestion';

@Component({
    selector: 'mm-true-false-quiz',
    templateUrl: './true-false-quiz.component.html',
    standalone: false
})
export class TrueFalseQuizComponent extends DelayedRenderedMessageComponent implements OnInit, OnDestroy {

    public static TYPE = 'TrueFalse';
    public static UPDATE_TYPE = 'updateTrueFalseQuiz';

    public responseItemData!: QuizResponseItemData<TrueFalseQuiz, TrueFalseQuizResponseItemDataText, TrueFalseQuizUpdateAnswer>;
    public question!: QuizQuestion;
    public negativeAnswer!: {
        isCorrectAnswer: boolean;
    };
    public positiveAnswer!: {
        isCorrectAnswer: boolean;
    };
    public quizNumber!: string;
    public isDeactivated: boolean | undefined;
    public updatedMessage = false;
    public sourceUrl: string | undefined;
    public sourceLabel: string | undefined;
    public questionTranslationId: string | undefined;
    public learningPackageTranslationId: string | undefined;
    private subscription: Subscription | undefined;
    public shouldShowMessage: boolean = false;

    constructor(private botatoChatManagerService: BotatoChatManagerService,
                private deactivateMessageService: DeactivateMessageService,
                private dialogViewModelCreatorService: DialogViewModelCreatorService,
                private changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    public ngOnDestroy(): void {
        if (this.subscription !== undefined) {
            this.subscription.unsubscribe();
        }
    }

    public ngOnInit(): void {
        if (this.message.type === TrueFalseQuizComponent.TYPE) {
            this.shouldShowMessage = true;
            this.updatedMessage = this.isMessageUpdated();
            if (this.updatedMessage) {
                this.createMessageUpdateData();
            } else {
                this.subscription = this.deactivateMessageService.deactivateOldCustomMessage(this.message);

                this.isDeactivated = this.message.data.deactivated !== undefined ? this.message.data.deactivated : false;

                this.createMessageData();
            }
        }

        if (this.message.type === TrueFalseQuizComponent.UPDATE_TYPE) {
            this.subscription = this.deactivateMessageService.setUpdateOfLastMessage(this.message.data, this.changeDetectorRef);
        }
    }

    public sendAnswer(answer: string): void {
        if (this.isDeactivated !== true) {
            void this.botatoChatManagerService.sendUserMessage(answer, 'quickreply');
        }
    }

    public isMessageUpdated(): boolean {

        const updateMessage = this.message.data.updateMessage;
        return updateMessage?.type === TrueFalseQuizComponent.UPDATE_TYPE && updateMessage.responseItemData !== undefined;
    }

    public mediaLoaded(): void {
        this.componentRenderingCompleted();
    }

    private createMessageData(): void {

        this.responseItemData = this.message.data.responseItemData;
        const quiz = this.responseItemData.quiz;
        this.question = quiz.quiz;
        this.quizNumber = this.responseItemData.learningSessionData.quizNumber;
        this.negativeAnswer = quiz.negativeAnswer;
        this.positiveAnswer = quiz.positiveAnswer;
    }

    private createMessageUpdateData(): void {

        this.responseItemData = this.message.data.updateMessage.responseItemData;
        const quizAnswerData = this.responseItemData.quizAnswerData!;
        this.sourceUrl = quizAnswerData.sourceUrl;
        this.sourceLabel = quizAnswerData.sourceLabel;
        this.questionTranslationId = quizAnswerData.id;
        this.learningPackageTranslationId = this.responseItemData.learningPackageTranslationId;
        this.question = quizAnswerData.quiz;
        this.quizNumber = quizAnswerData.quizNumber;
        this.negativeAnswer = quizAnswerData.negativeAnswer;
        this.positiveAnswer = quizAnswerData.positiveAnswer;
    }

    public override onAnyMessageSent(): void {
        if (this.isDeactivated !== true) {

            this.message.data.deactivated = true;
        }
    }
}
